import axios from 'axios';
import { API_REISSUE_DEVICE_AUTH_CODE } from '../../../endpoint';
import { OPEN_USER_PROMPT } from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { PAGE_PATH } from '../../../../lib/constants';

/**
 * デバイス認証コード再発行APIを呼び出す
 * @param {string} apiToken - API認証トークン
 * @returns
 */
const reissueDeviceAuthCode = apiToken => dispatch => {
  consolelog('[API CALL] reissueDeviceAuthCode()');
  configureAxiosForJSON(apiToken);

  // APIエンドポイント設定
  const url = API_REISSUE_DEVICE_AUTH_CODE;

  // キャンセルトークンの作成
  const { cancelToken, cancelTokenKey } = createCancelToken(
    'reissueDeviceAuthCode',
  );

  // リクエストパラメータを設定
  const axiosConfig = {
    cancelToken,
  };

  return axios
    .post(url, {}, axiosConfig)
    .then(res => {
      // TODO: 将来的には成功時201返却されるので、その際に処理を変更すること
      if (res.status === 200) {
        const buttonClose = i18nMessages['userPrompt.button.close'];
        dispatch({
          type: OPEN_USER_PROMPT,
          promptMessage: [
            i18nMessages['userPrompt.message.deviceAuth.reissue.success1'],
            i18nMessages['userPrompt.message.deviceAuth.reissue.success2'],
          ],
          buttonArray: [{ name: buttonClose, type: 1 }],
        });
      }
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        if (thrown.response && thrown.response.status === 403) {
          const closeButtonLabel = i18nMessages['userPrompt.button.close'];
          const errorMessages = [
            i18nMessages['userPrompt.message.deviceAuth.reissue.error'],
            i18nMessages['userPrompt.message.status404'], // 403の時リソースが見つからないエラーを表示
          ];
          dispatch({
            type: OPEN_USER_PROMPT,
            promptMessage: errorMessages,
            buttonArray: [{ name: closeButtonLabel, type: 1 }],
          });
        } else if (thrown.response && thrown.response.status === 404) {
          const logoutButtonLabel = i18nMessages['userPrompt.button.logout'];
          const notFoundMessages = [
            i18nMessages['userPrompt.message.deviceAuth.notSetSubscriptions.1'],
            i18nMessages['userPrompt.message.deviceAuth.notSetSubscriptions.2'],
          ];
          dispatch({
            type: OPEN_USER_PROMPT,
            promptMessage: notFoundMessages,
            buttonArray: [{ name: logoutButtonLabel, type: 1 }],
            onAccept: () => {
              window.location.href = PAGE_PATH.DS_LOGOUT;
            },
          });
        } else {
          handleErrorResponse(
            thrown,
            dispatch,
            '',
            i18nMessages['userPrompt.message.deviceAuth.reissue.error'],
          );
        }
      }
    })
    .finally(() => delCancelToken(cancelTokenKey));
};

export default reissueDeviceAuthCode;
